import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { useQueryStringState } from '@aibees/shared/hooks';
import { decodeQueryParamValues } from '@aibees/shared/utils';
import { useMemo } from 'react';
import { CompanyTableInfo } from '../../../types';

export function useSelectedLookalikeKey(
  item: CompanyTableInfo | PeopleTableInfo
) {
  const { params } = useQueryStringState();

  const lookalikeKey = item.link?.linkedin;

  const currentDomains = useMemo(
    () => decodeQueryParamValues(params.value),
    [params.value]
  );

  const selected = lookalikeKey
    ? currentDomains.some((itemDraft) => itemDraft === lookalikeKey)
    : false;

  return { selected, lookalikeKey };
}
